import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { EarlyAccessForm } from '../EarlyAccessForm';
import { useLaunchStatus } from '../../lib/launchStatus';

/**
 * Reusable "create a free account" banner dropped into guide articles
 * (typically once mid-article, once at the end). Swaps to the waiting-list
 * form during coming-soon mode, same as every other public CTA.
 */
export const GuideCTA = ({
  heading = 'We can send this request for you',
  body = "Tell us what you remember and we'll draft the letter, send it, track the legal deadline, and chase anyone who goes quiet. It's free.",
  ctaLabel = 'Create a free account',
  testIdPrefix = 'guide-cta',
}) => {
  const navigate = useNavigate();
  const { comingSoon } = useLaunchStatus();

  return (
    <section className="mx-2.5 mb-2.5 rounded-2xl bg-ground px-7 py-11 lg:px-12" data-testid={testIdPrefix}>
      <div className="max-w-3xl mx-auto space-y-3">
        <h2 className="font-heading text-[28px] sm:text-[34px] font-bold tracking-[-0.035em] leading-[1.05] text-ink">
          {heading}
        </h2>
        <p className="text-[17px] text-ink-70 leading-relaxed">{body}</p>
        {comingSoon ? (
          <div className="pt-2 max-w-sm">
            <p className="text-[15px] text-ink-55">
              We&apos;re inviting people in gradually while we finish testing. Leave your email and
              we&apos;ll let you know when it&apos;s your turn.
            </p>
            <EarlyAccessForm className="mt-4" testIdPrefix={`${testIdPrefix}-early-access`} />
          </div>
        ) : (
          <div className="pt-2">
            <Button size="lg" onClick={() => navigate('/register')} data-testid={`${testIdPrefix}-register-btn`}>
              {ctaLabel}
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default GuideCTA;
